<template>
    <div>
        <span>
            {{ $formatters.convertMinutesToNaturalLanguage(cDuration, 'hour') }}
        </span>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  params: Object
})

const { $formatters } = useNuxtApp()

const { params } = toRefs(props)

const CKeyduration = computed(() => {
  return params?.value?.keyduration || 'duration'
})

const cDuration = computed(() => {
  if (CKeyduration.value === 'tolerance') {
    return params?.value?.data?.tolerance
  }
  return params?.value?.data?.totalDuration || 0
})
</script>
